import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  .company-checkbox {
    flex: none;
    width: 16px;
    height: 16px;
    margin: 0.2rem 0.75rem 0 0;
    accent-color: ${(props) => props.theme.$dark_green};
    pointer-events: none;
  }

  .company-option-text {
    min-width: 0;
    line-height: 1.3;
  }

  .company-option-cnpj {
    color: ${(props) => props.theme.$gray600};
    font-variant-numeric: tabular-nums;
  }

  .company-option-own {
    font-weight: 600;
    color: ${(props) => props.theme.$primary};
  }

  .company-required-tip {
    position: absolute;
    top: 96px;
    left: calc(100% + 16px);
    width: 200px;
    padding: 0.625rem 0.875rem;
    border-radius: 4px;
    background: #283a54;
    color: ${(props) => props.theme.$white};
    font-size: 0.875rem;
    line-height: 1.35;
    z-index: 1051;

    &::before {
      content: '';
      position: absolute;
      top: 50%;
      left: -7px;
      margin-top: -7px;
      border-width: 7px 7px 7px 0;
      border-style: solid;
      border-color: transparent #283a54 transparent transparent;
    }
  }
`;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1020;
  background: rgba(33, 53, 74, 0.35);
`;
